module.exports = __webpack_public_path__ + "static/zama-5-93dbd053ed95dcf7755f99b6821eac77.gif";